import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import * as Api from "../../../../../api/cp/widgetSchedule";
import Breadcrumbs from "../../../UI/Breadcrumbs";
import SettingsSidebar from "./SettingsSidebar";
import WidgetEmbedCode from "../components/WidgetEmbedCode";
import SchedulePreview from "./Widget/SchedulePreview";

const WidgetScheduleEditor = ({event}) => {
    const {widgetKey} = useParams();
    const [settings, setSettings] = useState(null);
    const [isSaving, setSaving] = useState(false);
    const [params, setParams] = useState(null);
    const breadcrumbs = [
        'mainMenu.widgets',
        'mainMenu.schedule',
        'mainMenu.widget.update',
    ];

    useEffect(() => {
        getWidgetSettings();
    }, [widgetKey]);

    useEffect(() => {
        setParams({
            ...params,
            widgetKey: widgetKey,
            lang: settings?.lang || null,
        });
    }, [settings, widgetKey]);

    function handleChangeSettings (value) {
        setSettings({
            ...settings,
            ...value,
        });
    };

    async function getWidgetSettings() {
        try {
            const response = await Api.getWidgetScheduleSettings(widgetKey);
            setSettings(response || {});
        } catch (error) {
            console.error(error);
        }
    }

    async function handleSaveModel() {
        try {
            setSaving(true);
            await handleEditWidget(settings);
            setSaving(false);
        } catch (error) {
            console.error(error);
        }
    }

    async function handleEditWidget(model) {
        try {
            const response = await Api.updateWidgetSchedule(model.widgetKey, model);
            setSettings(response);
        } catch (error) {
            console.error(error);
        }
    }

    return (
        <section>
            <Breadcrumbs
                link={`/event/${event.eventPassword}`}
                activeCrumbs={breadcrumbs}
            />

            <div style={{marginBottom: '60px', display: 'flex', columnGap: '40px'}}>
                <div style={{width: '36%'}}>
                    <SettingsSidebar
                        eventPassword={event.eventPassword}
                        eventSettings={settings}
                        isSaving={isSaving}
                        onSaveModel={handleSaveModel}
                        onUpdateModel={handleChangeSettings}
                    />
                </div>
                <div style={{width: '64%'}}>
                    <WidgetEmbedCode
                        eventKey={event.eventKey}
                        widgetKey={widgetKey}
                        widgetName="schedule"
                        params={params}
                    />
                    <SchedulePreview
                        event={event}
                        settings={settings}
                        params={params}

                    />
                </div>
            </div> 
        </section>
    );
};

const mapStateToProps = (store) => {
    return {
        event: store.currentEvent,
    };
};

export default connect(mapStateToProps)(WidgetScheduleEditor);
